import React from "react";
import { Regular2Style } from "./css/Regular2Style";
import OutroLogo from "../../components/editor/Templates/OutroLogo";
import OutroText from "../../components/editor/Templates/OutroText";

const regular_2 = (props) => {
  return (
    <Regular2Style>
      <div className="poster flex-column">
        <div className="logo-container flex-column">
          <OutroLogo logo={props.file} />
        </div>
        <div className="text-wrapper flex-column">
          <OutroText
            id={props.id}
            text={props.text}
            textStyle={props.textStyle}
            editStatus={props.editStatus}
            onInputSlideText={props.onInputSlideText}
          />
        </div>
      </div>
    </Regular2Style>
  );
};

export default regular_2;
